import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { NotesComponent } from './notes/notes.component';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MrugamesSeedModule } from 'mrugames-seed';
import { NoteEditComponent } from './notes/note-edit/note-edit.component';
import { NoteCreateComponent } from './notes/note-create/note-create.component';
import { PublicNotesListComponent } from './notes/public-list/public-list.component';

export { NotesComponent } from './notes/notes.component';
export { PublicNotesListComponent } from './notes/public-list/public-list.component';

@NgModule({
  declarations: [NotesComponent, NoteEditComponent, NoteCreateComponent, PublicNotesListComponent],
  imports: [
    BrowserAnimationsModule,
    MrugamesSeedModule,
    MatFormFieldModule,
    MatListModule,
    CommonModule,
    MatTooltipModule,
  ],
  exports: [
    NotesComponent,
    PublicNotesListComponent,
  ]
})
export class MessagingServiceModule { }
